import { useState, useCallback } from 'react'
import { api } from '../utils/apiComponent/apiClient'
import { endpoints } from '../utils/endpoints'
import { showErrorToast, showSuccessToast } from '../utils/toast'

export function useWebinarTranslations() {
  const [loading, setLoading] = useState(false)

  // Lister toutes les traductions d'un webinaire (Admin)
  const getWebinarTranslations = useCallback(async (webinarId) => {
    setLoading(true)
    try {
      const data = await api.get(endpoints.getWebinarTranslations(webinarId))
      return data
    } catch (error) {
      const message = error?.message || 'Erreur lors du chargement des traductions'
      showErrorToast({ message })
      throw error
    } finally {
      setLoading(false)
    }
  }, [])

  // Obtenir une traduction spécifique (Admin)
  const getWebinarTranslation = useCallback(async (webinarId, language) => {
    setLoading(true)
    try {
      const data = await api.get(endpoints.getWebinarTranslation(webinarId, language))
      return data
    } catch (error) {
      const message = error?.message || 'Erreur lors du chargement de la traduction'
      showErrorToast({ message })
      throw error
    } finally {
      setLoading(false)
    }
  }, [])

  // Créer une traduction (Admin)
  const createWebinarTranslation = useCallback(async (webinarId, translationData) => {
    setLoading(true)
    try {
      const data = await api.post(
        endpoints.createWebinarTranslation(webinarId),
        translationData
      )
      showSuccessToast({ message: 'Traduction ajoutée avec succès' })
      return data
    } catch (error) {
      const message = error?.message || 'Erreur lors de la création de la traduction'
      showErrorToast({ message })
      throw error
    } finally {
      setLoading(false)
    }
  }, [])

  // Mettre à jour une traduction (Admin)
  const updateWebinarTranslation = useCallback(async (webinarId, language, translationData) => {
    setLoading(true)
    try {
      const data = await api.put(
        endpoints.updateWebinarTranslation(webinarId, language),
        translationData
      )
      showSuccessToast({ message: 'Traduction modifiée avec succès' })
      return data
    } catch (error) {
      const message = error?.message || 'Erreur lors de la modification de la traduction'
      showErrorToast({ message })
      throw error
    } finally {
      setLoading(false)
    }
  }, [])

  // Supprimer une traduction (Admin)
  const deleteWebinarTranslation = useCallback(async (webinarId, language) => {
    setLoading(true)
    try {
      await api.delete(endpoints.deleteWebinarTranslation(webinarId, language))
      showSuccessToast({ message: 'Traduction supprimée avec succès' })
    } catch (error) {
      const message = error?.message || 'Erreur lors de la suppression de la traduction'
      showErrorToast({ message })
      throw error
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    getWebinarTranslations,
    getWebinarTranslation,
    createWebinarTranslation,
    updateWebinarTranslation,
    deleteWebinarTranslation
  }
}

